import React, { useState } from "react";
import ExpanderPanel from "@rio-cloud/rio-uikit/ExpanderPanel";
import Checkbox from "@rio-cloud/rio-uikit/Checkbox";

interface DinamicSmartRoutePreferencesProps {
  preferences?: {
    energy: boolean;
    fastest: boolean;
    economic: boolean;
  };
  onPreferencesChange?: (preferences: { energy: boolean; fastest: boolean; economic: boolean }) => void;
}

export interface IDinamicSmartRoutePreferences {
  energy: boolean;
  fastest: boolean;
  economic: boolean;
}

const DinamicSmartRoutePreferences: React.FC<DinamicSmartRoutePreferencesProps> = ({
  preferences: externalPreferences,
  onPreferencesChange,
}) => {
  const [internalPreferences, setInternalPreferences] = useState({
    energy: false,
    fastest: false,
    economic: false,
  });

  const preferences = externalPreferences || internalPreferences;

  const handlePreferenceChange = (name: string, checked: boolean) => {
    const newPreferences = {
      ...preferences,
      [name]: checked,
    };

    if (onPreferencesChange) {
      onPreferencesChange(newPreferences);
    } else {
      setInternalPreferences(newPreferences);
    }
  };

  return (
    <div>
      <div>
        <Checkbox
          name="energy"
          checked={preferences.energy}
          onChange={(e) => handlePreferenceChange("energy", e.target.checked)}
        >
          Rota com menor consumo energético
        </Checkbox>
      </div>
      <div>
        <Checkbox
          name="fastest"
          checked={preferences.fastest}
          onChange={(e) => handlePreferenceChange("fastest", e.target.checked)}
        >
          Rota mais rápida
        </Checkbox>
      </div>
      <div>
        <Checkbox
          name="economic"
          checked={preferences.economic}
          onChange={(e) => handlePreferenceChange("economic", e.target.checked)}
        >
          Rota mais econômica
        </Checkbox>
      </div>
    </div>
  );
};

export default DinamicSmartRoutePreferences;

